import { ColumnDef } from '@tanstack/react-table';
import { formatTableTimestamp } from '../../utils/formatTableDate';
import {
  SortableHeader,
  TruncatedCell,
  DownloadedCheckmark,
} from '@/components';
import { ProblemRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DocumentSource, DocumentType } from '../../viewer';
import { DASH } from '../../utils/displayValues';

export const createProblemsColumns = (): ColumnDef<ProblemRecord>[] => [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) =>
      row.original.name === null ? (
        DASH
      ) : row.original.name ? (
        <TruncatedCell text={row.original.name} />
      ) : (
        'No data available'
      ),
  },
  {
    id: 'dateUploaded',
    accessorFn: (row) => row.createdAt,
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Date Uploaded</SortableHeader>
    ),
    cell: ({ row }) => formatTableTimestamp(row.original.createdAt),
  },
  {
    accessorKey: 'sourceType',
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Source Type</SortableHeader>
    ),
    cell: ({ row }) => row.original.sourceType || 'No data available',
  },
  {
    id: 'markedDownloaded',
    enableSorting: false,
    header: '',
    cell: ({ row }) =>
      row.original.markedDownloaded ? <DownloadedCheckmark /> : null,
  },
  {
    id: 'actions',
    enableSorting: false,
    header: '',
    cell: ({ row }) => (
      <div className="flex items-center justify-end gap-1">
        <PatientDocumentViewButton
          disabled={!row.original.sourceType}
          documentKey={{
            source: DocumentSource.MEDICAL_RECORDS,
            type: DocumentType.PROBLEMS,
            problemId: row.original.id,
            sourceType: row.original.sourceType,
            name: row.original.name === null ? DASH : row.original.name,
          }}
        />
      </div>
    ),
  },
];
